import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=35658912&scoped=true&"
import script from "./CustomerGroups.vue?vue&type=script&lang=js&"
export * from "./CustomerGroups.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroups.vue?vue&type=style&index=0&id=35658912&prod&lang=scss&scoped=true&"
import style1 from "./CustomerGroups.vue?vue&type=style&index=1&id=35658912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35658912",
  null
  
)

export default component.exports